const TOKEN_KEY = 'playgen_token';
const USER_KEY = 'playgen_user';

export interface AuthUser {
  id: string;
  feishuId: string;
  name: string;
  avatar?: string | null;
  email?: string | null;
  createdAt?: string;
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function removeToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function isAuthenticated(): boolean {
  return !!getToken();
}

export function setUserInfo(user: AuthUser): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function getUserInfo(): AuthUser | null {
  const data = localStorage.getItem(USER_KEY);
  if (!data) return null;
  try {
    return JSON.parse(data) as AuthUser;
  } catch {
    return null;
  }
}

export function logout(): void {
  removeToken();
  window.location.href = '/login';
}
